import { colors } from '@constants/colors';

export const useStyles = () => {
  return {
    root: {
      display: 'flex',
      gap: 2,
      alignItems: 'center',
      color: colors.white,
      mb: 1.5,
    },
    avatar: {
      position: 'relative',
      width: 64,
      height: 64,
      flexShrink: 0,

      // UserAvatar renders the initials and the picture as two sibling layers
      // that cross-fade, so they have to be stacked here — left in flow, the
      // picture drops below the block and lands on the menu under it. Same
      // treatment UserAvatarButton gives them in the header.
      '& .MuiAvatar-root': {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
      },
    },
    name: {
      flex: 1,
      minWidth: 0,

      '& .MuiTypography-root': {
        fontFamily: 'var(--primary-font-bold)',
        fontSize: 20,
        lineHeight: '87%',
        overflow: 'hidden',

        '&:first-of-type': {
          display: 'inline-block',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          maxWidth: '100%',
        },
      },
    },
    editButton: {
      flexShrink: 0,
      padding: 0.75,
      color: colors.white,

      '&:hover': {
        backgroundColor: colors.white_10,
      },
    },
    editIcon: {
      width: 18,
      height: 18,
      fill: 'currentColor',
    },
  };
};
